import { Component, Input, OnInit, SimpleChanges } from '@angular/core'
import { LocaleCode } from 'src/app/interfaces/locale'
import { LogEvent, LoginType } from 'src/app/interfaces/log'
import { GeneralService } from 'src/app/services/general/general.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { RouterService } from 'src/app/services/router/router.service'
import { UserService } from 'src/app/services/user/user.service'
import { environment } from 'src/environments/environment'
import { calculateIsBackgroundColorDark } from 'src/utils/color'

@Component({
  selector: 'header-base',
  templateUrl: './header-base.component.html',
  styleUrls: ['./header-base.component.scss'],
})
export class HeaderBaseComponent implements OnInit {
  constructor(
    public userService: UserService,
    private logService: LogService,
    private generalService: GeneralService,
    private routerService: RouterService,
    private localeService: LocaleService
  ) {}

  @Input() showLoginButton = true
  @Input() showDrawerButton = true
  @Input() backgroundColor: string | undefined
  isBackgroundColorDark = false
  isProduction = environment.production
  selectedLanguage = this.localeService.locale
  languages = Object.values(LocaleCode)

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('backgroundColor')) {
      const calculateTimeout = setTimeout(() => {
        this.isBackgroundColorDark = calculateIsBackgroundColorDark('.header-container')
        clearTimeout(calculateTimeout)
      }, 10)
    }
  }

  toggleDrawer(): void {
    this.logService.eventLogging(LogEvent.HEADER_DRAWER_CLICKED, { from: location.pathname })
    this.generalService.openDrawer()
  }

  onClickLogin(): void {
    if (!this.userService.isLoggedIn) {
      this.routerService.navigate('login', { queryParams: { type: LoginType.HEADER } })
      this.logService.eventLogging(LogEvent.ENTER_LOGIN)
    }
  }

  /** develop only */
  onChangeLanguage(): void {
    this.userService.updateUserPrivateData({ languageCode: this.selectedLanguage }).subscribe(() => {
      this.localeService.locale = this.selectedLanguage
    })
  }
}
